import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteRenderInputParams,
  Chip,
  TextField
} from "@mui/material";
import { useTranslation } from "react-i18next";

export type FirstAidOptions = { locationName: string; floorName: string };
export type SelectFirstAidOptions = {
  options: FirstAidOptions[];
  reason: AutocompleteChangeReason | null;
};

type Props = {
  containerRef: React.RefObject<HTMLDivElement>;
  tagLimit: number;
  firstAidOptions: FirstAidOptions[];
  selectFirstAidOptions: SelectFirstAidOptions;
  setSelectFirstAidOptions: (newSelect: SelectFirstAidOptions) => void;
};

export function ScheduleFirstAidSelect({
  containerRef,
  tagLimit,
  firstAidOptions,
  selectFirstAidOptions,
  setSelectFirstAidOptions
}: Readonly<Props>) {
  const { t } = useTranslation();

  const genOptionLabel = (option: FirstAidOptions) =>
    option.locationName + " - " + option.floorName;

  return (
    <Autocomplete
      ref={containerRef}
      limitTags={tagLimit}
      data-testid="schedule-firstAid-filtering"
      multiple
      id="tags-outlined4"
      disableCloseOnSelect
      options={firstAidOptions}
      getOptionLabel={genOptionLabel}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.locationName + option.floorName}>
            {genOptionLabel(option)}
          </li>
        );
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            label={genOptionLabel(option)}
            key={option.locationName + option.floorName}
          />
        ));
      }}
      sx={{
        flex: "1 1 280px",
        minWidth: { xs: "100%", sm: 280 },
        maxWidth: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: 1.5
        }
      }}
      onChange={(event, values, reason) => setSelectFirstAidOptions({ options: values, reason })}
      isOptionEqualToValue={(option, value) =>
        option.locationName === value.locationName && option.floorName === value.floorName
      }
      value={selectFirstAidOptions.options}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          // variant="outlined"
          size="small"
          fullWidth
          placeholder={t("Choose the location and floor of first aid users")}
          slotProps={{ input: { ...params.InputProps, sx: { height: "50px" } } }}
        />
      )}
    />
  );
}
